// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2T4FH","col":"Table_col__3Nd1c","fulfillmentStatus":"Table_fulfillmentStatus__25L2_","emailCol":"Table_emailCol__3iNuw"};